<template>
  <div>
    <v-sheet tile height="54" class="d-flex ma-4">
      <v-btn icon @click="$refs.tCalendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-subheader v-if="$refs.tCalendar">
        {{ $refs.tCalendar.title }}
      </v-subheader>
      <v-spacer />
      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        label="type"
      />
      <v-spacer />
      <v-btn icon @click="$refs.tCalendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-sheet height="600">
      <div class="d-flex justify-center">
        <div
          class="d-flex mx-2 mb-2"
          v-for="(legend, index) in legends"
          :key="index"
        >
          <div
            class="rounded-circle mr-3 my-auto"
            :style="`backgroundColor: ${legend.color}; width: 18px; height: 18px;`"
          ></div>
          <div class="text-caption legend">
            {{ legend.name }}
          </div>
        </div>
      </div>

      <v-calendar
        ref="tCalendar"
        v-model="value"
        :type="type"
        :events="events"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        :first-time="minDayTime"
        @change="getEvents"
        @click:event="showEvent"
        @click:more="viewDay"
        @click:date="viewDay"
        :key="timestamp"
      />
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <teacher-calendar-event
          :key="timestamp"
          v-model="selectedEvent"
          @close="selectedOpen = false"
          @deleted="eventDeleted"
        />
      </v-menu>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import TeacherCalendarEvent from "./TeacherCalendarEvent.vue";
import {schedule2Event} from '@/utils/scheduling/scheduleUtils.js'

export default {
  props: {
    teacher: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    timestamp: Date.now(),
    type: "month",
    types: ["month", "week", "day"],
    events: [],
    value: "",
    selectedEvent: null,
    selectedElement: null,
    selectedOpen: false,
    minDayTime: "08:00",
    legends: [ {name: 'Scheduled', color: '#2196F3'}, {name: 'Cancelled', color: '#757575'}]
  }),
  components: { TeacherCalendarEvent },
  computed: {
    ...mapGetters(["currentUser", "isAppLoading"]),
  },
  mounted() {
    console.log("Mounted schedules component");
  },

  methods: {
    ...mapActions(["addErrorMessage"]),
    viewDay({ date }) {
      console.log("view day", date);
      this.type = "day";
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;

        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    calculateMinTime() {
      // return '08:00'; //Temporary hard code; this events returned from server isn't accurate

      // find min hours
      if (this.type === "day" && this.events && this.events.length > 0) {
        const minTime = this.events.reduce(
          (min, e) =>
            moment(e.start).isSameOrBefore(min) ? moment(e.start) : min,
          moment(this.events[0].start)
        );
        this.minDayTime = minTime.format("HH:mm");
      }
    },
    getEvents({ start, end }) {
      console.log("get events");
      const min = moment(start.date);
      const max = moment(end.date);

      this.events = [];

      this.fetchSchedules(min, max).then((data) => {
        this.events = this.events.concat(this.convertSchedules2Events(data));

        this.calculateMinTime();
      });
    },

    async fetchSchedules(min, max) {
      const params = {
        start_date: min.format("YYYY-MM-DD"),
        end_date: max.format("YYYY-MM-DD"),
        teacher_ids: this.teacher.id
      };

      return await this.$axios
        .get("/teacher-schedule", { params })
        .then((resp) => {
          console.log(resp);
          return resp.data;
        })
        .catch((error) => {
          this.addErrorMessage(error.data.message | "Error fetching calendar");
        });
    },

    convertSchedules2Events(schedules) {
      console.log("converting schedules to events", schedules);
      if (schedules && schedules.length > 0) {
        return schedules.map((s) => {
          return schedule2Event(s);
        });
      } else {
        return [];
      }
    },

    eventDeleted() {
      this.selectedOpen = false;
      //reload calendar
      this.timestamp = Date.now();
    },
  },
};
</script>